/*
去掉markdown文本的格式以及非文字段落，作为语音的输入
 */

export function cleanMarkdown(markdown) {
    // 1. 去除 LaTeX 公式（`$...$` 以及 `$$...$$`）
    markdown = markdown.replace(/\$\$(.*?)\$\$/gs, ""); // 多行公式
    markdown = markdown.replace(/\$(.*?)\$/g, "$1"); // 行内公式
    markdown = markdown.replace(/\\\((.*?)\\\)/gs, "$1"); // 行内公式 \( ... \)
    markdown = markdown.replace(/\\\[(.*?)\\\]/gs, ""); // 多行公式 \[ ... \]

    // 2. 去除 Markdown 代码块（```代码```）
    markdown = markdown.replace(/```[\s\S]*?```/g, "");

    // 3. 去除 Markdown 行内代码（`code`）
    markdown = markdown.replace(/`([^`]+)`/g, "");

    // 4. 去除标题（# 开头的行）
    markdown = markdown.replace(/^#{1,6}\s*(.*)/gm, "$1");

    // 5. **去除 Markdown 图片和链接**
    markdown = markdown.replace(/!\[.*?\]\(.*?\)/g, ""); // 去除图片 ![alt](url)
    markdown = markdown.replace(/\[.*?\]\(.*?\)/g, ""); // 去除超链接 [text](url)

    // 6. 去除 HTML 标签（如 <div>、<p> ）
    markdown = markdown.replace(/<\/?[^>]+(>|$)/g, "");

    // 7. 去除多余的 * _ - + 符号（用于列表、加粗、斜体）
    markdown = markdown.replace(/(\*|_|-|\+){2,}/g, ""); // **加粗** 或 __加粗__ 变成普通文本
    markdown = markdown.replace(/^\s*[-*+]\s+/gm, ""); // 去除无序列表前缀
    markdown = markdown.replace(/^\s*\d+\.\s+/gm, ""); // 去除有序列表前缀

    // 8. 去除表格
    markdown = markdown.replace(/\|.*?\|/g, "");
    markdown = markdown.replace(/-+\|?-+/g, "");

    // 9. 去除多余的换行符和空格
    markdown = markdown.replace(/\n{2,}/g, "\n").trim();

    return markdown;
}